import classes from "./Statuses.module.css";
export default function Statuses({ status, isLabel = true }) {
  const statusesColor = {
    pending: {
      bgColor: "var(--main-color)",
      color: "#D9FFE2",
      label: "Pending",
    },
    completed: {
      bgColor: "rgb(125 125 125)",
      color: "#F4F4F4",
      label: "Completed",
    },
    new: {
      bgColor: "var(--icon-bg-color)",
      color: "var(--main-color)",
      label: "New",
    },
    active: {
      bgColor: "var(--icon-bg-color)",
      color: "var(--main-color)",
      label: "Active",
    },
    inactive: {
      bgColor: "var(--main-color)",
      color: "#D9FFE2",
      label: "Inactive",
    },
  };
  return (
    <div
      className={`${classes.statusWrapper} ${
        !isLabel ? classes.withoutLabel : ""
      }`}
      style={{ backgroundColor: statusesColor[status]?.bgColor }}
    >
      {isLabel && (
        <p style={{ color: statusesColor[status]?.color }}>
          {statusesColor[status]?.label}
        </p>
      )}
    </div>
  );
}
